<template>
  <div
    role="status"
    aria-label="Loading offer"
    class="bg-fill-brand-secondary border-[3px] border-border-brand rounded-3xl w-[312px] px-6 py-[30px] flex flex-col gap-4"
  >
    <span class="sr-only">Loading offer</span>
    <!-- Title skeleton -->
    <Skeleton
      :width="titleWidths[skeletonIndex % titleWidths.length]"
      height="26px"
      border-radius="4px"
    />

    <!-- Image skeleton -->
    <div class="h-[180px]">
      <Skeleton width="100%" height="100%" border-radius="16px" />
    </div>

    <!-- CTA button skeleton -->
    <Skeleton width="100%" height="40px" border-radius="9999px" />

    <!-- Footer skeleton -->
    <div class="flex items-center justify-between w-full">
      <!-- Left: 2 icon circle skeletons (overlapping, matching gating icon layout) -->
      <div class="flex items-center">
        <Skeleton width="32px" height="32px" border-radius="50%" />
        <Skeleton
          width="32px"
          height="32px"
          border-radius="50%"
          class="-ml-[5px]"
        />
      </div>
      <!-- Right: 1 admin icon circle skeleton -->
      <Skeleton width="32px" height="32px" border-radius="50%" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import Skeleton from "@/components/ui/layout/skeleton.vue";

const props = defineProps<{
  index?: number;
}>();

const titleWidths = ["85%", "75%", "90%"];

const skeletonIndex = computed(() => props.index ?? 0);
</script>
